import PropTypes from 'prop-types';
import AlterListMembershipActionMetadata from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import AlterListMembershipActionDetail from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const AlterListMembershipActionHistoryCard = ({
  actionLabel,
  actionMetadata
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(AlterListMembershipActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
AlterListMembershipActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(AlterListMembershipActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default AlterListMembershipActionHistoryCard;